import React from 'react';
import CardChevronWrapper from '../atoms/CardChevronWrapper';
import Icon from '~lib/frontend/design-system/components/Icon';
const CardHeaderChevron = ({ open }) => (React.createElement(CardChevronWrapper, { "$open": open },
    React.createElement(Icon, { icon: 'ic_chevron_down_sm', "$size": '18px', "$color": 'neutralFillMuted' })));
export default CardHeaderChevron;
